<template>
  <div class="mobile-navigation-sub-country-select-fi">
    <div class="mobile-navigation-sub-country-select-fi__header">
      <headline-fi
        v-if="title"
        :size="21"
        class="mobile-navigation-sub-country-select-fi__title"
        tag="div"
        color="brand"
        :html-content="title"
      />
      <headline-fi
        v-if="subtitle"
        :size="36"
        class="mobile-navigation-sub-country-select-fi__subtitle"
        tag="h1"
        :html-content="subtitle"
      />
    </div>
    <country-selection-locale-fi
      is-navigation
      @show-country-selection="$emit('show-country-selection')"
    />
  </div>
</template>

<script setup lang="ts">
import { HeadlineFi } from 'atoms';
import { computed } from 'vue';

import CountrySelectionLocaleFi from '@/components/country-selection-locale-fi/CountrySelectionLocaleFi.vue';
import { useDict, useFischer } from '@/composables/fischerPlugin';

defineOptions({ name: 'MobileNavigationSubCountrySelectFi' });

defineEmits<{ 'show-country-selection': [] }>();

const dict = useDict();
const fischer = useFischer();

const title = computed(() =>
  dict.get('global-Labels.Country-Selection.Title', [fischer.brandName()]),
);

const subtitle = computed(() => dict.get('global-Labels.Country-Selection.Subtitle'));
</script>

<style scoped src="./mobile-navigation-sub-country-select-fi" />
